import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useParams } from "react-router-dom";
import useNavigateWithBase from "../hooks/useNavigateWithBase"; // ✅ 新しいフックをインポー
import DOMPurify from 'dompurify'; // ✅ HTMLインジェクション対策
import '../CSS/AddProject.css';

const AddProject = () => {
    const navigate = useNavigateWithBase();
    const { personalId } = useParams();
    const location = useLocation(); // ✅ 遷移時のstateを取得

    const [projectName, setProjectName] = useState('');
    const [projectDescription, setProjectDescription] = useState('');
    const [clientName, setClientName] = useState('');
    const [status, setStatus] = useState(1.0);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    // ✅ 受け取った `selectedUserId` を使い、なければ `localStorage` の値を利用
    const userPersonalId = location.state?.selectedUserId || personalId;
    const companyCode = localStorage.getItem('company_code');

    // ✅ 入力値のサニタイズ（HTMLインジェクション防止）
    const sanitizeInput = (input) => {
        return DOMPurify.sanitize(input);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
    
        if (!projectName || !clientName || status === undefined) {
            setError('⚠️ プロジェクト名・クライアント名・進捗ステータスは必須です。');
            setLoading(false);
            return;
        }
    
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                setError('❌ ログインが必要です。');
                setLoading(false);
                return;
            }
    
            const requestData = {
                action: 'addProject',
                company_code: companyCode,
                name: sanitizeInput(projectName),
                description: sanitizeInput(projectDescription),
                client_name: clientName,
                status: parseFloat(status),
                created_by: userPersonalId
            };
    
            const response = await axios.post(
                'https://ozq0s15jhf.execute-api.ap-northeast-3.amazonaws.com/prod/api/projects',
                JSON.stringify(requestData),
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
    
            console.log("📌 APIレスポンス:", response.data);
    
            if (response.data && response.status === 200) {
                const projectId = response.data.project_id || "不明";
                alert(`✅ プロジェクトが追加されました！\nプロジェクトID: ${projectId}`);
                navigate('/portal'); // ✅ 成功後リダイレクト
            } else {
                throw new Error(response.data.message || "プロジェクトの追加に失敗しました。");
            }
        } catch (err) {
            console.error('❌ プロジェクト追加エラー:', err);
            setError(err.message || '❌ プロジェクトの追加に失敗しました。');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className="add-project-container">
            <h2>新規プロジェクト追加</h2>
            {error && <p className="error-message">{error}</p>}
            <form onSubmit={handleSubmit} className="add-project-form">
                <div className="form-group">
                    <label>プロジェクト名 <span className="required">*</span></label>
                    <input
                        type="text"
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>プロジェクト概要</label>
                    <textarea
                        value={projectDescription}
                        onChange={(e) => setProjectDescription(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>クライアント名 <span className="required">*</span></label>
                    <input
                        type="text"
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                        required
                    />
                </div>

                <div className="form-group">
                    <label>進捗ステータス</label>
                    <select value={status} onChange={(e) => setStatus(parseFloat(e.target.value))}>
                        <option value={1.0}>未着手</option>
                        <option value={3.0}>ヒアリング中</option>
                        <option value={5.0}>企画書作成中</option>
                        <option value={7.0}>運用準備中</option>
                        <option value={9.0}>運用中</option>
                    </select>
                </div>

                <button type="submit" className="submit-button" disabled={loading}>
                    {loading ? '追加中...' : 'プロジェクト追加'}
                </button>
                {/* ポータルページへ戻るボタン */}
                <button
                    className="back-button"
                    onClick={() => navigate('/portal')}
                    disabled={loading} // ローディング中はボタンも無効化
                >
                    ポータルへ戻る
                </button>
            </form>
        </div>
    );
};

export default AddProject;
